var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.companyName) +
              " hat dir folgende positive Nachricht geschickt"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "InfoBox",
        {
          staticClass: "my-3",
          attrs: { "with-icon": false, type: "purple-lightest" }
        },
        [_c("nl2br", { attrs: { tag: "div", text: _vm.text } })],
        1
      ),
      _vm._v(" "),
      !_vm.sendOff
        ? _c("p", [
            _vm._v("\n\t\tWenn du auf "),
            _c("b", [_vm._v(_vm._s(_vm.buttonText))]),
            _vm._v(" drückst, wird "),
            _c("b", [_vm._v(_vm._s(_vm.companyName))]),
            _vm._v(
              " informiert und erhält für die\n\t\tnäheren Detailabstimmungen deine E-Mail Adresse und deine Mobilnummer.\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.sendOff
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("ApplicantSendOff", {
                attrs: {
                  customer: _vm.message.customer,
                  "is-anonymous": false,
                  "with-company-name": false
                },
                model: {
                  value: _vm.sendOffData,
                  callback: function($$v) {
                    _vm.sendOffData = $$v
                  },
                  expression: "sendOffData"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex mt-4" }, [
                _c("div", { staticClass: "flex-grow-1 mr-3" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.sendOff = false
                        }
                      }
                    },
                    [_vm._v("Bewerbung doch nicht zurückziehen")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("Button", {
                      attrs: {
                        text: "Bewerbung zurückziehen",
                        disabled: !_vm.sendOffDataValid || _vm.sendingRequest,
                        loading: _vm.sendingRequest
                      },
                      on: { click: _vm.submit }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _c("div", { staticClass: "d-flex align-items-center mt-4" }, [
            _c("div", { staticClass: "flex-grow-1 mr-3" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.sendOff = true
                    }
                  }
                },
                [_vm._v("Bewerbung zurückziehen")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("Button", {
                  attrs: {
                    text: _vm.buttonText,
                    disabled: _vm.sendingRequest,
                    loading: _vm.sendingRequest,
                    icon: "checkmark"
                  },
                  on: { click: _vm.submit }
                })
              ],
              1
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }